import { MutableRefObject, useRef } from 'react'

/**
 * Captures the latest value of `value` in a ref that is updated on every
 * render. Use inside `useDataCollectionSource` / async callbacks where you
 * want access to the freshest prop value WITHOUT forcing a rebuild of the
 * wrapping resource (which would cancel in-flight queries).
 */
export function useLatestRef<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value)
  ref.current = value
  return ref
}
